// extracted by mini-css-extract-plugin
export var divider = "_pa-0";
export var systemMessage = "_pa-1";
export var systemMessageWrapper = "_pa-2";